// extracted by mini-css-extract-plugin
export default {"btn":"ticketAreaButton__btn__Gmb72","disabled":"ticketAreaButton__disabled__d7Zdx"};